import produce from 'immer';
import {
  types,
  CountriesState,
  GetCountriesSuccess,
  GetCountriesPending,
  GetCountriesError,
  CountryActionType
} from './types';

// Actions

export const actions = {
  getCountries: (): CountryActionType => ({ type: types.GET_COUNTRIES_ASYNC.REQUEST })
};

// Initial State
export const initialState: CountriesState = {
  countries: [],
  loading: false,
  error: undefined
};

// Reducer
export const reducer = (state: CountriesState = initialState, action: CountryActionType): CountriesState => {
  return produce(state, draft => {
    switch (action.type) {
      case types.GET_COUNTRIES_ASYNC.SUCCESS:
        draft.countries = (action as GetCountriesSuccess).payload;
        draft.error = initialState.error;
        break;
      case types.GET_COUNTRIES_ASYNC.PENDING:
        draft.loading = (action as GetCountriesPending).payload;
        break;
      case types.GET_COUNTRIES_ASYNC.ERROR:
        draft.error = (action as GetCountriesError).payload;
        break;
      default:
      // Do nothing
    }
    return draft;
  });
};
